import { AxiosInstance } from "axios";

export function getContentBySlugBuilder(apiClient: AxiosInstance) {
  return async function getContentBySlug<T>(
    type: string,
    slug: string,
    params?: {
      full_slug?: string;
      page?: number;
      size?: number;
    }
  ): Promise<T | null> {
    try {
      const response = await apiClient.get(
        `/learning/api/v2/${type}/${slug}/`,
        {
          params: params,
        }
      );
      return response.data;
    } catch {
      return null;
    }
  };
}
